import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

class ElementFadeIns {
    constructor() {
        const elementGroup = document.querySelector('.js-element-group');
        if (elementGroup) {
            this.elementGroupInit();
        }
        const contentGroup = document.querySelector('.js-content-group');
        if (contentGroup) {
            this.contentGroupInit();
        }
        const sideSlide = document.querySelector('.js-side-slide');
        if (sideSlide) {
            this.sideSlideInit();
        }
        const upSlide = document.querySelector('.js-up-slide');
        if (upSlide) {
            this.upSlideInit();
        }
        const outsideToInsideGroup = document.querySelector('.js-outside-to-inside-group');
        if (outsideToInsideGroup) {
            this.outsideToInsideInit();
        }
        const rowsFade = document.querySelector('.js-row-fade');
        if (rowsFade) {
            this.rowsFadeInit();
        } /*
        const sideShuffleGroup = document.querySelector('.js-side-shuffle-group');
        if (sideShuffleGroup) {
          this.sideShuffleGroupInit();
        }*/
    }

    rowsFadeInit() {
        const run = () => {
            const all = Array.from(document.querySelectorAll('.js-row-fade'));
            if (!all.length) return;

            // 0) Initial-States setzen, um FOUC zu vermeiden
            gsap.set('.js-row-fade .line-inner', { x: '-100%', autoAlpha: 0 });
            gsap.set('.js-row-fade .js-row-content > *', { y: '24px', autoAlpha: 0 });

            // Optional: Reduced Motion respektieren
            const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            if (reduceMotion) {
                gsap.set('.js-row-fade .line-inner', { x: 0, autoAlpha: 1 });
                gsap.set('.js-row-fade .js-row-content > *', { y: 0, autoAlpha: 1 });
                return;
            }

            // 1) Adjacent-Gruppen aus direkten Siblings bauen
            const groups = [];
            let i = 0;
            while (i < all.length) {
                const group = [all[i]];
                // nur direkte Siblings derselben Klasse einsammeln
                let next = all[i].nextElementSibling;
                while (next && next.classList && next.classList.contains('js-row-fade')) {
                    group.push(next);
                    i++;
                    next = all[i].nextElementSibling;
                }
                groups.push(group);
                i++;
            }

            // 2) Pro Gruppe ein Trigger + Timeline
            const groupDelay = 0.25; // feste Verzögerung zwischen Items einer Gruppe
            const innerStagger = 0.2; // Stagger innerhalb eines Items

            groups.forEach((group) => {
                const triggerEl = group[0]; // Startpunkt des Verbunds

                const tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: triggerEl,
                        start: 'top 80%',
                        toggleActions: 'play none none none',
                        markers: false
                    },
                    defaults: { ease: 'power2.out' }
                });

                group.forEach((item, idx) => {
                    const at = idx * groupDelay;

                    // erst die "line-inner" des Items
                    tl.to(
                        item.querySelectorAll('.line-inner'),
                        {
                            x: 0,
                            autoAlpha: 1,
                            duration: 0.8,
                            stagger: innerStagger
                        },
                        at
                    );

                    // dann der eigentliche Content des Items
                    tl.to(
                        item.querySelectorAll('.js-row-content > *'),
                        {
                            y: 0,
                            delay: 0.2,
                            autoAlpha: 1,
                            duration: 0.8,
                            stagger: innerStagger
                        },
                        at + 0.1
                    );
                });
            });
        };

        if (document.readyState !== 'loading') run();
        else document.addEventListener('DOMContentLoaded', run);
    }

    /*rowsFadeInit() {
    const run = () => {
      const fadeRows = document.querySelectorAll('.js-row-fade');

      fadeRows.forEach(item => {

        let lineTL = gsap.timeline({
          scrollTrigger: {
            trigger: item,
            start: "top 80%",
            markers: false,
            toggleActions : 'play none none none'
          },
          ease: 'power2.out'
        }).to(item.querySelectorAll('.line-inner'), {
          x: "0",
          opacity : 1,
          duration: .8,
          stagger : .2
        }).to(item.querySelectorAll('.js-row-content > *'), {
          y: "0",
          opacity : 1,
          duration: .8,
          stagger : .2
        })

      });
    }

    if (document.readyState !== 'loading') run();
    else document.addEventListener('DOMContentLoaded', run);
  }*/

    elementGroupInit() {
        const run = () => {
            const elementGroups = document.querySelectorAll('.js-element-group');

            elementGroups.forEach((item) => {

                // console.log("group found")
                // data-delay robust auslesen (Komma → Punkt erlauben)
                const baseDelay = parseFloat((item.dataset.delay || '0').replace(',', '.')) || 0;

                gsap.timeline({
                    delay: baseDelay,
                    scrollTrigger: {
                        trigger: item,
                        start: 'top 90%',
                        markers: false,
                        toggleActions: 'play none none none'
                    }
                }).from(item.querySelectorAll(':scope > *'), {
                    opacity: 0,
                    y: '24px',
                    duration: 1,
                    ease: 'power3.out',
                    stagger: 0.15
                });
            });
        };

        if (document.readyState !== 'loading') run();
        else document.addEventListener('DOMContentLoaded', run);
    }

    contentGroupInit() {
        window.addEventListener('load', () => {
            const contentGroups = document.querySelectorAll('.js-content-group');

            contentGroups.forEach(function (item) {
                let tl = gsap
                    .timeline({
                        scrollTrigger: {
                            trigger: item,
                            start: 'top 90%',
                            markers: false,
                            toggleActions: 'play none none none'
                        }
                    })
                    .from(item.querySelectorAll(':scope > *'), {
                        opacity: 0,
                        y: '30px',
                        duration: 1.4,
                        ease: 'power3.out',
                        stagger: 0.15
                    });
            });
        });
    }

    sideSlideInit() {
        const run = () => {
            const groups = document.querySelectorAll('.js-side-slide');

            groups.forEach((item) => {
                const targets = item.querySelectorAll(':scope > *');

                // 1) Sofort (früh) verstecken & versetzen (kein Flash)
                gsap.set(targets, { autoAlpha: 0, x: '6vw' });

                // Optional: Accessibility – Animationen respektieren
                const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
                if (reduceMotion) {
                    gsap.set(targets, { autoAlpha: 1, x: 0 });
                    return;
                }

                // 2) Dann beim Scrollen sauber ins Ziel animieren
                gsap.timeline({
                    scrollTrigger: {
                        trigger: item,
                        start: 'top 90%',
                        toggleActions: 'play none none none' // oder 'play none none reverse'
                        // once: true, // falls du nur einmal abspielen willst
                    }
                }).to(targets, {
                    autoAlpha: 1,
                    x: 0,
                    duration: 1.5,
                    ease: 'power3.out',
                    stagger: 0.2
                });
            });
        };

        if (document.readyState !== 'loading') run();
        else document.addEventListener('DOMContentLoaded', run);
    }

    upSlideInit() {
        const run = () => {
            const groups = document.querySelectorAll('.js-up-slide');

            groups.forEach((item) => {
                const targets = item.querySelectorAll(':scope > *');

                // 1) Sofort (früh) verstecken & versetzen (kein Flash)
                gsap.set(targets, { autoAlpha: 0, y: '4vh' });

                // Optional: Accessibility – Animationen respektieren
                const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
                if (reduceMotion) {
                    gsap.set(targets, { autoAlpha: 1, x: 0 });
                    return;
                }

                // 2) Dann beim Scrollen sauber ins Ziel animieren
                gsap.timeline({
                    scrollTrigger: {
                        trigger: item,
                        start: 'top 90%',
                        toggleActions: 'play none none none' // oder 'play none none reverse'
                        // once: true, // falls du nur einmal abspielen willst
                    }
                }).to(targets, {
                    autoAlpha: 1,
                    y: 0,
                    duration: 1,
                    ease: 'power3.out',
                    stagger: 0.15
                });
            });
        };

        // Früher laufen als 'load', um FOUC zu verhindern
        if (document.readyState !== 'loading') run();
        else document.addEventListener('DOMContentLoaded', run);
    }

    outsideToInsideInit() {
        window.addEventListener('load', () => {
            const outsideToInsideGroups = document.querySelectorAll('.js-outside-to-inside-group');

            outsideToInsideGroups.forEach((group) => {
                const kids = group.querySelectorAll(':scope > *'); // direkte Kinder
                if (kids.length < 2) return;

                gsap.timeline({
                    scrollTrigger: {
                        trigger: group,
                        start: 'top 90%',
                        markers: false,
                        toggleActions: 'play none none none'
                    }
                })
                    .from(
                        kids[0],
                        {
                            // Index 0: von links
                            opacity: 0,
                            x: '-6vw',
                            duration: 1.5,
                            ease: 'power3.out'
                        },
                        0
                    ) // Startposition im Timeline (statt delay)
                    .from(
                        kids[1],
                        {
                            // Index 1: von rechts
                            opacity: 0,
                            x: '6vw',
                            duration: 1.5,
                            ease: 'power3.out'
                        },
                        0.2
                    ); // 200ms nach dem ersten
            });
        });
    }
}

export default ElementFadeIns;
